// @ts-strict-ignore
import {Component, Input, OnInit} from "@angular/core";
import {Tag, TagType} from "@models";
import {SimTaggingService} from "@services";

@Component({
	selector: "sim-tags-chip-view",
	templateUrl: "./sim-tags-chip-view.component.html",
	styleUrls: ["./sim-tags-chip-view.component.scss"],
	standalone: false,
})
export class SimTagsChipViewComponent implements OnInit {
	@Input({required: true}) tagIds: string[];
	@Input({required: true}) tagType: TagType;
	@Input() allTags: Tag[];

	protected currentTags: Tag[] = [];

	constructor(private _simTaggingService: SimTaggingService) {}

	ngOnInit(): void {
		if (!this.allTags) {
			this._simTaggingService
				.getAllTagsOfTagType(this.tagType)
				.then((allTags) => (this.allTags = allTags))
				.then(() => this._initCurrentTags());
		} else {
			this._initCurrentTags();
		}
	}

	private _initCurrentTags() {
		this.currentTags = this.tagIds.map((tagId) => {
			return this.allTags.filter((tag) => tag.id === tagId).pop();
		});
	}
}
